/** @jsx jsx */
import { useContext } from "react"
import { Text, Box, jsx } from "theme-ui"
import Buttons from "./Buttons"

import { Indicator } from "./Icons"
import { SoldOut } from "../svg"

import enums from "../../util/enums"

import { Context } from "../../context/MainContext"
import { ShopifyContext } from "../../context/ShopifyContext"

function FlavorsList({
  bundleSize,
  colors,
  flavors,
  index,
  numItems,
  selectedVariants,
  setIndex,
}) {
  const {
    store: { caseBuilderMode },
  } = useContext(Context)
  const { checkout, handleDecrement, handleIncrement } = useContext(
    ShopifyContext
  )

  const styles = {
    flavors: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent:
        caseBuilderMode === enums.mode.view ? "flex-start" : "space-between",
      "svg.active": {
        fontSize: "0.75em",
        marginLeft: "0.25em",
      },
      "@media screen and (max-width: 900px)": {
        p: {
          fontSize: "26px",
        },
        svg: {
          width: "26px",
          height: "26px",
        },
      },
    },
    count: {
      color: numItems > bundleSize ? "#E85A2E" : "inherit",
    },
  }
  return (
    <Box
      sx={{
        gridColumn: "7 / -1",
        gridRow: 2,
        padding: "40px 20px 0 0",
        zIndex: 1,
        "@media screen and (max-height: 1000px)": {
          padding: "30px 20px 0 0",
        },
        "@media screen and (max-height: 800px)": {
          padding: "20px 20px 0 0",
        },
      }}
    >
      {flavors.map((flavor, idx) => {
        return (
          <Box
            key={flavor.title}
            onMouseOver={() =>
              caseBuilderMode === enums.mode.view && setIndex(idx)
            }
            onTouchStart={() =>
              caseBuilderMode === enums.mode.view && setIndex(idx)
            }
            sx={{
              ...styles.flavors,
              color:
                caseBuilderMode === enums.mode.bundle &&
                (flavor.available === false || flavor.disabled)
                  ? "#E85A2E"
                  : "inherit",
            }}
          >
            {caseBuilderMode === enums.mode.bundle &&
              (flavor.available === false || flavor.disabled) && (
                <SoldOut style={{ position: "absolute", left: "-1.05em" }} />
              )}
            <Text
              as="p"
              sx={{
                whiteSpace: "nowrap",
                opacity:
                  (caseBuilderMode === enums.mode.view && idx === index) ||
                  (caseBuilderMode === enums.mode.bundle &&
                    !selectedVariants.includes(flavor.productId))
                    ? "0.5"
                    : "1",
              }}
            >
              {flavor.title}
            </Text>
            {caseBuilderMode === enums.mode.bundle && (
              <Buttons
                productId={flavor.productId}
                bundle={checkout.bundle}
                numItems={numItems}
                bundleSize={bundleSize}
                disabled={flavor.available === false || flavor.disabled}
                increment={() => {
                  handleIncrement(
                    flavor[`1 OF ${bundleSize}PACK`],
                    flavor.productId,
                    checkout.bundleIndex
                  )
                }}
                decrement={() =>
                  handleDecrement(
                    flavor[`1 OF ${bundleSize}PACK`],
                    flavor.productId,
                    checkout.bundleIndex
                  )
                }
                color={
                  flavor.available === false || flavor.disabled
                    ? "#E85A2E"
                    : colors.text
                }
              />
            )}
            {caseBuilderMode === enums.mode.view && index === idx && (
              <Indicator color={colors.text} />
            )}
          </Box>
        )
      })}
      {caseBuilderMode === enums.mode.bundle && (
        <Text
          as="p"
          variant="body"
          aria-label="Bundle Size"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <span sx={styles.count}>{numItems}</span>
          &nbsp;
          {"/"}
          &nbsp;
          {bundleSize}
        </Text>
      )}
    </Box>
  )
}

export default FlavorsList
